export const QUICK_ACTION_MENU_HEIGHT = 40
export const QUICK_ACTION_MENU_OFFSET = 10
